import React from 'react';
import styles from './index.module.less';
import AddAccount from '../AddAccount';
import { useTranslation } from 'react-i18next';
import Image from 'next/image';
import { useIsMobile } from '@/hooks/useIsMobile';
import { useAddAccountModal } from '@/context/AddAccountModalProvider';

export default function LeakDetection() {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const featureIcon = (
    <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.5 5.73077L7.97619 12.5L18.5 1.5"
        stroke="#38C13D"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
  const { openAddAccountModal } = useAddAccountModal();
  const features = isMobile
    ? [
        {
          icon: featureIcon,
          title: t('Free Leak Scan'),
        },
        {
          icon: featureIcon,
          title: t('Privacy-first'),
        },
        {
          icon: featureIcon,
          title: t('No Credit Card Required'),
        },
      ]
    : [
        {
          icon: featureIcon,
          title: t('Free Leak Scan'),
        },
        {
          icon: featureIcon,
          title: t('No Credit Card Required'),
        },
        {
          icon: featureIcon,
          title: t('Privacy-first'),
        },
      ];
  return (
    <div className={styles.container}>
      <div className={styles.mainContent}>
        <div className={styles.mainLeft}>
          <Image src="/images/dmca/left-section.png" alt="leak-detection" width={382} height={240} />
        </div>
        <div className={styles.mainRight}>
          <div className={styles.title}>{t('Get a Free Content Leak Detection')}</div>
          <AddAccount
            getAccount={() => {
              openAddAccountModal();
            }}
            useNewModal={true}
          />
        </div>
      </div>
      <div className={styles.features}>
        {features.map((feature, index) => (
          <div className={styles.feature} key={index}>
            <div>{feature.icon}</div>
            <p>{feature.title}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
